<script lang="ts">
  import Avatar from "$components/+blocks/Avatar/Avatar.svelte";
  import type { AvatarDetails } from "app/models/shared-types";

  export let avatars: AvatarDetails[];
  export let size: string = "size-12";
  export let textSize: string = "text-md";
  export let radius: string | undefined = undefined;
  export let count: number = 3;

  // remove duplicate avatars by creating a new Map object:
  // the key is the avatar's uuid (so there will only be unique ones added)
  // the value is the avatar data itself
  const avatarsMap = new Map(avatars.map((avatar) => [avatar.uuid, avatar]));

  // convert the Map back to an array to get an array of unique avatars
  const uniqueAvatars = Array.from(avatarsMap.values());
</script>

<div class="flex space-x-1">
  {#each uniqueAvatars.slice(0, count) as avatar (avatar.uuid)}
    <span title={avatar.handle}>
      <Avatar
        label={avatar.handle && avatar.handle[0]}
        mainImage={avatar.profileImage}
        backgroundColor={avatar.profileColor}
        {size}
        {textSize}
        {radius}
      />
    </span>
  {/each}

  {#if uniqueAvatars.length > count}
    <Avatar
      label={`+${Math.abs(uniqueAvatars.length - count)}`}
      {size}
      {textSize}
      {radius}
      wrapperClasses="bg-neutral-200 dark:bg-white/10"
    />
  {/if}
</div>
